export default __webpack_public_path__ + "static/media/work.0e402573.png";